import {useQuery} from "@tanstack/react-query";
import {readProductDetailIn} from "../../../../../api/product/ProductInApi";
import {productInDetailMapInit} from "../state";
import {ProductInDetailSearchParamType} from "../interface";
import {useLocation} from "react-router-dom";

type Props = {
    param: ProductInDetailSearchParamType;
};

export const useReadProductDetailIn = ({param}: Props) => {
    const {pathname} = useLocation()

    const {data} = useQuery({
        queryKey: ["readProductDetailIn", param],
        queryFn: async () => await readProductDetailIn(param),
        select: (res) => res?.data.result ?? productInDetailMapInit,
        enabled: pathname.includes("product/detail") ? true : param.enabled ?? false
    });

    return {data};
};
